module.exports = __webpack_public_path__ + "img/noob-logo.3f7703be.png";